/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Log } from '../logging';

/**
 * Clears all client-side storage belonging to this origin:
 * localStorage and sessionStorage.
 *
 * Used on a fresh-install launch (`freshInstall=true` from the
 * LG shell) so that stale iframe-origin data does not survive
 * an uninstall / reinstall cycle.
 */
export function clearAppStorage(): void {
    try {
        window.localStorage.clear();
    } catch (error: unknown) {
        Log.i('[clearAppStorage] Failed to clear localStorage', JSON.stringify(error));
    }

    try {
        window.sessionStorage.clear();
    } catch (error: unknown) {
        Log.i('[clearAppStorage] Failed to clear sessionStorage', JSON.stringify(error));
    }
}
